import { render, staticRenderFns } from "./AsistenciaAuto.vue?vue&type=template&id=11b6dbd0&scoped=true&"
var script = {}
import style0 from "./AsistenciaAuto.vue?vue&type=style&index=0&id=11b6dbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b6dbd0",
  null
  
)

export default component.exports